
<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11.5511 8L11.5 8V12.3638C11.5168 12.3562 11.5339 12.349 11.5511 12.3423V8ZM10.5 13.5613H10.5056L10.5 13.5695L11.3332 14.1226L13.9301 15.8467C14.3855 16.1491 14.9992 16.0298 15.3081 15.5789L15.3244 15.5552C15.6398 15.0949 15.5175 14.4654 15.0526 14.1568L12.5511 12.496V8C12.5511 7.44772 12.1034 7 11.5511 7H11.5C10.9477 7 10.5 7.44771 10.5 8V12.5613V13.5613ZM14.4832 15.0136L12.2957 13.5613H12.3477L14.4995 14.9899L14.4832 15.0136Z"
    fill="#4B4C52"
  />
</svg>
